export default "/images/999e596f895a0e089c247fa9fa8c6b8b.avif";